module.exports = __webpack_public_path__ + "b5dd9dba39162e1200d19c96bc356dd4.svg";